export const GroupTimeLine = {
    YES: { value: true },
    NO: { value: false },
};

export enum IsDisbursedShown {
    NOT_SHOWN = "0",
    SHOWN = "1",
}
